export default __webpack_public_path__ + "static/media/thermometer_half_white.35f58d9a.svg";